import React, {useEffect, useState} from "react";
import {useDebounce} from "../../hooks/useDebounce";

export default function KeywordSearch({
                                        id,
                                        label,
                                        value = "",
                                        onChange = () => console.warn("No handler supplied"),
                                        placeholder = "Type to Search",
                                      }) {
  const [currentValue, setCurrentValue] = useState(value);
  const debouncedCurrentValue = useDebounce(currentValue, 300);

  useEffect(() => {
    onChange(debouncedCurrentValue);
  }, [debouncedCurrentValue]);
  const pathName = window.location.pathname;
  if (pathName === '/atae/member-directory' || pathName === '/atae/directory/member-directory') {
    placeholder = "Name Search";
  }
  return (
    <div className="flex flex-2 h-full items-center pr-4">
      <label className="sr-only" htmlFor={id}>
        {label}
      </label>
      <img
        className="w-6 h-6 mr-5"
        src="/themes/custom/nada/images/icons/search.png"
        alt=""
      />
      <input
        id={id}
        className="form-text text-lg break:text-3xl rounded-none m-0 p-0 mr-4 w-full"
        name={id}
        type="text"
        placeholder={placeholder}
        value={currentValue}
        onChange={(e) => {
          setCurrentValue(e.target.value);
        }}
      />
    </div>
  );
}
